// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CopyPlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-copyplanmodalcontainer" */ "./CopyPlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.CopyPlanModalContainer
        };
    });
export const LazyCopyPlanModalContainer = /*#__PURE__*/ lazy(CopyPlanModalContainerLazyLoader);
